import type { IQuestion } from "@/types/types";
import { type FC } from "react";
import Carousel from "@/components/carousel/Carousel";
import { useLanguage } from "@/context/language-context/LanguageContext";
import { useQuery } from "@tanstack/react-query";
import { getImages } from "@/lib/services/images";

interface QuestionModalContentProps {
  item: IQuestion;
}

const QuestionModalContent: FC<QuestionModalContentProps> = ({ item }) => {
  const { language } = useLanguage();

  const { data: imageUrls } = useQuery({
    queryKey: ["question", item.questionId],
    queryFn: () => getImages({ images: item.images }),
    placeholderData: [],
  });

  return (
    <div data-testid="question-modal-content" className="space-y-4">
      <Carousel
        urls={imageUrls}
        startIndex={0}
        loop
        className="w-full"
        panelClassName="h-80 md:h-[28rem]"
      />

      <div>
        <p className="text-md text-ib-gray-darkest">{item[language]}</p>
      </div>
    </div>
  );
};

export default QuestionModalContent;
